import React, { useEffect, useRef } from 'react'
import { GoogleSsoButton, Or, SocialLogin } from 'Features/auth/components/LoginScreen/Login.styled'
import { GOOGLE_CLIENT_ID } from 'Consts/google'
import { isMobile } from 'react-device-detect'
import { useGoogleLogin } from 'Features/auth/api/ssoLogin'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface CredentialResponse {
  credential: string
  select_by: string
}

type GoogleSsoLoginProps = {
  onError: (error: any) => void
  source?: string
}

// eslint-disable-next-line no-var
var google = window.google

export const GoogleSsoLogin = ({ onError, source }: GoogleSsoLoginProps) => {
  const ref = useRef(null)
  const { t } = useTranslation('auth')
  const { mutate: login } = useGoogleLogin({ onError })
  const isWebkit = /(iPhone|iPod|iPad).*AppleWebKit/i.test(navigator.userAgent)
  const navigate = useNavigate()
  const handleCredentialResponse = (response: CredentialResponse) => {
    login({ googleToken: response.credential })
    if (source === 'reAuthModal') {
      navigate('/account-selector', { replace: true })
    }
  }

  const renderGoogleButton = () => {
    const buttonNode = ref.current
    if (buttonNode && google) {
      google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
      })

      google.accounts.id.renderButton(buttonNode, {
        size: 'large',
        width: isMobile ? '295px' : '400px',
        type: 'standard',
        text: 'signin_with',
        shape: 'rectangular',
        logo_alignment: 'center',
      })
    }
  }

  useEffect(() => {
    renderGoogleButton()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [google?.accounts])

  return (
    <SocialLogin noBorder={true}>
      <GoogleSsoButton ref={ref}></GoogleSsoButton>
      <Or>{t(isWebkit ? '' : 'login.or')}</Or>
    </SocialLogin>
  )
}
